export interface FsLprRawFleetReadPlateAttributes {
  type: {
    value: string;
    confidenceScore: number;
  };
  state: {
    value: string;
    confidenceScore: number;
  };
  ocr: {
    value: string;
    confidenceScore: number;
  };
}
